import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from '../services/auth/auth.service';
import { Globals } from '../services/globals';
import { Router } from '@angular/router';
import { ToastService } from '../services/toasts/toast.service';
import { UserDTO } from '../models/user/user.dto';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']

})
export class LoginComponent implements OnInit {
  year: number = new Date().getFullYear();
  fieldTextType!: boolean;
  loginForm!: UntypedFormGroup;
  submitted = false;
  loading = false;
  version: string = Globals.appVersion;
  showNavigationArrows: any = true;
  constructor(private router: Router, private formBuilder: UntypedFormBuilder
    , private authService: AuthService, private toastService: ToastService
  ) { }
  ngOnInit(): void {
    Globals.clearLocalStorage();
    console.log("I am in LoginComponent")
    this.loginForm = this.formBuilder.group({
      identifier: ['', [Validators.required]],
      password: ['', Validators.required],
    });
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  get f() { return this.loginForm.controls; }
  onSubmit() {
    // Globals.saveToken("123456");
    // const user: UserDTO = {
    //   email: "admin@example.com",
    //   district_identifier:"NADIA",
    //   first_name: "John",
    //   last_name: "Doe",
    //   name: "John Doe",
    //   phone_number: "+1-123-456-7890",
    //   status: 1,
    //   role: {
    //     id: 1,
    //     name: "super admin"
    //   }
    // };

    // Globals.saveUser(user);
    // this.router.navigate(["/admin/dashboard"])
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.loading = true;
    this.authService.login(this.loginForm.controls['identifier'].value, this.loginForm.controls['password'].value)
      .subscribe(
        response => {
          this.loading = false;
          if (response.flag) {
            Globals.saveToken(response.body.access_token);
            Globals.saveUser(response.body.user);
            this.router.navigate(["/admin/dashboard"])
            this.toastService.success("Hi " + Globals.getUser()?.name + ", Welcome Back!")
          } else {
            this.toastService.error(response.messages[0] || "Failed to login! email or password does not match!")
          }
          this.submitted = false
        })


  }

}
